// extracted by mini-css-extract-plugin
export var button = "Button-module--button--094fe";
export var sizeSM = "Button-module--sizeSM--782b6";
export var sizeMD = "Button-module--sizeMD--501f9";
export var sizeLG = "Button-module--sizeLG--8f835";
export var fullWidth = "Button-module--fullWidth--a6733";
export var fullWidthMobile = "Button-module--fullWidthMobile--02ce7";
export var disabled = "Button-module--disabled--cd4ef";
export var themeOutlined = "Button-module--themeOutlined--4faf8";